import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex justify-center items-center fixed inset-y-0 right-0 overflow-x-hidden overflow-y-hidden z-50 w-full"
}
const _hoisted_2 = { class: "flex relative w-1/2 h-auto" }
const _hoisted_3 = { class: "flex flex-col bg-white w-full max-h-screen rounded-2xl shadow p-8 overflow-y-auto" }
const _hoisted_4 = { class: "flex flex-row justify-between mb-8" }
const _hoisted_5 = {
  key: 0,
  class: "font-semibold text-lg"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Edit ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" reimbursement request ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" extra charge ")
const _hoisted_9 = {
  key: 1,
  class: "font-semibold text-lg"
}
const _hoisted_10 = { class: "flex flex-col" }
const _hoisted_11 = {
  key: 0,
  class: "w-full mb-4"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Select a category", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("option", { value: "extra_charges" }, "Extra charge", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("option", { value: "reimbursements" }, "Reimbursement", -1)
const _hoisted_15 = [
  _hoisted_12,
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = {
  key: 1,
  class: "w-full relative"
}
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { class: "flex flex-row justify-between items-center" }
const _hoisted_19 = {
  key: 0,
  class: "text-gray-400"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-4 w-4 text-black",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_21 = {
  key: 0,
  class: "absolute flex flex-col bg-white shadow rounded w-full h-72 overflow-y-auto p-1 z-50"
}
const _hoisted_22 = {
  key: 0,
  class: "p-4"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, "No companies found...", -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = {
  key: 2,
  class: "w-full relative"
}
const _hoisted_27 = ["disabled"]
const _hoisted_28 = { class: "flex flex-row justify-between items-center" }
const _hoisted_29 = {
  key: 0,
  class: "text-gray-400"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-4 w-4 text-black",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_31 = {
  key: 0,
  class: "absolute flex flex-col bg-white shadow rounded w-full h-72 overflow-y-auto p-1 z-50"
}
const _hoisted_32 = {
  key: 0,
  class: "p-4"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, "No users found...", -1)
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = ["onClick"]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Select a category", -1)
const _hoisted_37 = ["value"]
const _hoisted_38 = { class: "flex flex-row items-start mt-4" }
const _hoisted_39 = { class: "w-1/2 mr-2" }
const _hoisted_40 = { class: "w-1/2 ml-2" }
const _hoisted_41 = ["value"]
const _hoisted_42 = {
  key: 4,
  class: "flex flex-row mt-4"
}
const _hoisted_43 = { class: "flex flex-row rounded bg-gray-100 px-4 py-5 w-4/5 items-center" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6 text-gray-500",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"
  })
], -1)
const _hoisted_45 = {
  key: 0,
  class: "text-gray-400 ml-4"
}
const _hoisted_46 = /*#__PURE__*/_createTextVNode(" Upload your receipt(s)... ")
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", { class: "text-error" }, "(Required)", -1)
const _hoisted_48 = [
  _hoisted_46,
  _hoisted_47
]
const _hoisted_49 = {
  key: 1,
  class: "flex flex-row ml-4"
}
const _hoisted_50 = { class: "flex flex-wrap justify-center space-x-2" }
const _hoisted_51 = ["onClick"]
const _hoisted_52 = ["onClick"]
const _hoisted_53 = /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fas",
  "data-icon": "times",
  class: "w-3 ml-3",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 352 512"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
  })
], -1)
const _hoisted_54 = [
  _hoisted_53
]
const _hoisted_55 = ["onClick"]
const _hoisted_56 = /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fas",
  "data-icon": "times",
  class: "w-3 ml-3",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 352 512"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
  })
], -1)
const _hoisted_57 = [
  _hoisted_56
]
const _hoisted_58 = { class: "flex flex-row items-center justify-center rounded-full px-6 ml-4 bg-primary h-16 w-1/5 hover:cursor-pointer" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("span", { class: "text-white" }, "Upload", -1)
const _hoisted_60 = { class: "mt-4" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("div", { class: "h-px w-full bg-gray-300 my-4" }, null, -1)
const _hoisted_62 = { class: "flex flex-row justify-between mt-4" }
const _hoisted_63 = ["disabled"]
const _hoisted_64 = {
  key: 0,
  style: {"border-top-color":"transparent"},
  class: "mr-2 mt-4 w-4 h-4 border-2 rounded-full animate-spin"
}
const _hoisted_65 = /*#__PURE__*/_createElementVNode("span", null, "Save", -1)
const _hoisted_66 = ["disabled"]
const _hoisted_67 = {
  key: 0,
  style: {"border-top-color":"transparent"},
  class: "mr-2 mt-4 w-4 h-4 border-2 rounded-full animate-spin"
}
const _hoisted_68 = /*#__PURE__*/_createElementVNode("span", null, "Create", -1)
const _hoisted_69 = {
  key: 1,
  class: "bg-black opacity-50 fixed inset-y-0 right-0 z-40 w-full"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Close = _resolveComponent("Close")!
  const _component_CompanyCard = _resolveComponent("CompanyCard")!
  const _component_UserCard = _resolveComponent("UserCard")!
  const _component_TextField = _resolveComponent("TextField")!
  const _component_NewCurrencyField = _resolveComponent("NewCurrencyField")!
  const _component_TextArea = _resolveComponent("TextArea")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.openModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                (_ctx.editing)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                      _hoisted_6,
                      (_ctx.typeOfExpense === 'reimbursements')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _hoisted_7
                          ], 64))
                        : (_ctx.typeOfExpense === 'extra_charges')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _hoisted_8
                            ], 64))
                          : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_9, "Add new expense")),
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                }, [
                  _createVNode(_component_Close)
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                (!_ctx.editing)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.typeOfExpense) = $event)),
                        class: "bg-gray-100 rounded px-4 py-5 mt-4 focus:outline-none focus:ring-2 focus:ring-black w-full"
                      }, _hoisted_15, 512), [
                        [_vModelSelect, _ctx.typeOfExpense]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.editing)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("button", {
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openSelectedCompanies && _ctx.openSelectedCompanies(...args))),
                        class: "rounded bg-gray-100 pl-4 py-5 w-full disabled:cursor-not-allowed mb-4",
                        disabled: _ctx.editing
                      }, [
                        _createElementVNode("div", _hoisted_18, [
                          (!_ctx.client_id)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_19, "Select client"))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", null, _toDisplayString(_ctx.selectedCompanyName), 1),
                          _hoisted_20
                        ])
                      ], 8, _hoisted_17),
                      (_ctx.selectedCompanies)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            (_ctx.companies.length === 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_24))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companies, (emp, i) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: i,
                                class: "flex flex-col"
                              }, [
                                _createElementVNode("button", {
                                  onClick: ($event: any) => (_ctx.selectCompany(i)),
                                  class: "hover:bg-background-secondary rounded p-4 w-full"
                                }, [
                                  _createVNode(_component_CompanyCard, {
                                    companyName: emp.visible_name
                                  }, null, 8, ["companyName"])
                                ], 8, _hoisted_25)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.typeOfExpense === 'reimbursements')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _createElementVNode("button", {
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.openSelectedEmployees && _ctx.openSelectedEmployees(...args))),
                        class: "rounded bg-gray-100 pl-4 py-5 w-full disabled:cursor-not-allowed mb-4",
                        disabled: _ctx.editing
                      }, [
                        _createElementVNode("div", _hoisted_28, [
                          (!_ctx.talent_id)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_29, "Select employee"))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", null, _toDisplayString(_ctx.selectedEmployeeName), 1),
                          _hoisted_30
                        ])
                      ], 8, _hoisted_27),
                      (_ctx.selectedEmployees)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                            (_ctx.talent.length === 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_32, _hoisted_34))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.talent, (emp, i) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: i,
                                class: "flex flex-col"
                              }, [
                                _createElementVNode("button", {
                                  onClick: ($event: any) => (_ctx.selectEmployee(i)),
                                  class: "hover:bg-background-secondary rounded p-4 w-full"
                                }, [
                                  _createVNode(_component_UserCard, {
                                    firstName: emp.first_name,
                                    lastName: emp.last_name,
                                    position: emp.job_title
                                  }, null, 8, ["firstName", "lastName", "position"])
                                ], 8, _hoisted_35)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_TextField, {
                  modelValue: _ctx.title,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.title) = $event)),
                  name: "title",
                  label: "Title",
                  error: _ctx.errors.title
                }, null, 8, ["modelValue", "error"]),
                (_ctx.typeOfExpense === 'reimbursements')
                  ? _withDirectives((_openBlock(), _createElementBlock("select", {
                      key: 3,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.detail) = $event)),
                      class: "bg-gray-100 rounded px-4 py-5 mt-4 focus:outline-none focus:ring-2 focus:ring-black"
                    }, [
                      _hoisted_36,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.details, (item, i) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: i,
                          value: item.value
                        }, _toDisplayString(item.name), 9, _hoisted_37))
                      }), 128))
                    ], 512)), [
                      [_vModelSelect, _ctx.detail]
                    ])
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    _createVNode(_component_NewCurrencyField, {
                      modelValue: _ctx.amount,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.amount) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.currency) = $event)),
                      class: "bg-gray-100 rounded w-full px-4 py-5 focus:outline-none focus:ring-2 focus:ring-black"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currencies, (item, i) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: i,
                          value: item.value
                        }, _toDisplayString(item.name), 9, _hoisted_41))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.currency]
                    ])
                  ])
                ]),
                (_ctx.typeOfExpense === 'reimbursements')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                      _createElementVNode("div", _hoisted_43, [
                        _hoisted_44,
                        (_ctx.preview.length === 0 && _ctx.files.length === 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_45, _hoisted_48))
                          : (_openBlock(), _createElementBlock("div", _hoisted_49, [
                              _createElementVNode("div", _hoisted_50, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (file, i) => {
                                  return (_openBlock(), _createElementBlock("span", {
                                    key: i,
                                    onClick: ($event: any) => (_ctx.viewReceipt(file.url)),
                                    class: "mt-2 px-4 py-2 rounded-full text-gray-500 bg-gray-200 font-semibold text-sm flex align-center w-max cursor-pointer active:bg-gray-300 transition duration-300 ease"
                                  }, [
                                    _createTextVNode(_toDisplayString(_ctx.getFileName(file.url)) + " ", 1),
                                    _createElementVNode("button", {
                                      class: "bg-transparent hover focus:outline-none",
                                      onClick: _withModifiers(($event: any) => (_ctx.deteleFile(file.identifier)), ["stop"])
                                    }, _hoisted_54, 8, _hoisted_52)
                                  ], 8, _hoisted_51))
                                }), 128)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.preview, (name, i) => {
                                  return (_openBlock(), _createElementBlock("span", {
                                    class: "mt-2 ml-2 px-4 py-2 rounded-full text-gray-500 bg-gray-200 font-semibold text-sm flex align-center w-max cursor-none active:bg-gray-300 transition duration-300 ease",
                                    key: i
                                  }, [
                                    _createTextVNode(_toDisplayString(name) + " ", 1),
                                    _createElementVNode("button", {
                                      class: "bg-transparent hover focus:outline-none",
                                      onClick: _withModifiers(($event: any) => (_ctx.deteleLocalFile(i)), ["stop"])
                                    }, _hoisted_57, 8, _hoisted_55)
                                  ]))
                                }), 128))
                              ])
                            ]))
                      ]),
                      _createElementVNode("label", _hoisted_58, [
                        _hoisted_59,
                        _createElementVNode("input", {
                          type: "file",
                          accept: "image/png, image/jpeg, application/pdf",
                          class: "hidden",
                          multiple: "",
                          onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.uploadFiles && _ctx.uploadFiles(...args)))
                        }, null, 32)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_60, [
                  _createVNode(_component_TextArea, {
                    modelValue: _ctx.note,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.note) = $event)),
                    name: "note",
                    placeholder: "Write a note (Optional)"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _hoisted_61,
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("button", {
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
                  class: "btn-outline-lg"
                }, "Cancel"),
                (_ctx.editing)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args))),
                      class: "w-52 relative btn-filled-lg flex flex-row items-center justify-center disabled:cursor-not-allowed",
                      disabled: 
                !_ctx.canSubmit || _ctx.loadingReimbursement || _ctx.loadingExtraCharge
              
                    }, [
                      (_ctx.loadingReimbursement || _ctx.loadingExtraCharge)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_64))
                        : _createCommentVNode("", true),
                      _hoisted_65
                    ], 8, _hoisted_63))
                  : (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args))),
                      class: "w-52 relative btn-filled-lg items-center flex flex-row justify-center disabled:cursor-not-allowed",
                      disabled: 
                !_ctx.canSubmit || _ctx.loadingReimbursement || _ctx.loadingExtraCharge
              
                    }, [
                      (_ctx.loadingReimbursement || _ctx.loadingExtraCharge)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_67))
                        : _createCommentVNode("", true),
                      _hoisted_68
                    ], 8, _hoisted_66))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.openModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_69))
      : _createCommentVNode("", true)
  ]))
}